// Import Swiper for product block carousel
import Swiper, { Scrollbar, Autoplay } from 'swiper';

/**
 * Blog post functionality - Table of Contents generator and Product Block
 */
export default {
  init() {
    this.generateTableOfContents();
    this.initializeSmoothScroll();
    this.initializeProductBlock();
  },

  /**
   * Create URL-friendly slug from text
   * @param {string} text - Text to slugify
   * @returns {string} - URL-friendly slug
   */
  slugify(text) {
    // Polish characters map
    const polishMap = {
      'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n',
      'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
      'Ą': 'A', 'Ć': 'C', 'Ę': 'E', 'Ł': 'L', 'Ń': 'N',
      'Ó': 'O', 'Ś': 'S', 'Ź': 'Z', 'Ż': 'Z',
    };

    return text
      .split('')
      .map(char => polishMap[char] || char)
      .join('')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_]+/g, '-')
      .replace(/^-+|-+$/g, '');
  },

  /**
   * Generate table of contents from H2 headings
   */
  generateTableOfContents() {
    const $tocContainer = $('#blog-toc-list');
    const $contentArea = $('.entry-content');
    
    if (!$tocContainer.length || !$contentArea.length) {
      return;
    }

    // Find all H2 headings in the content, excluding those inside product blocks
    const $headings = $contentArea.find('h2').filter(function() {
      return !$(this).closest('.blog-product-block-container').length;
    });
    
    if ($headings.length === 0) {
      // Hide TOC if no headings found
      $('#blog-toc-wrapper').hide();
      return;
    }

    // Clear existing TOC items
    $tocContainer.empty();

    // Track used IDs to avoid duplicates
    const usedIds = {};

    // Generate TOC items
    $headings.each((index, heading) => {
      const $heading = $(heading);
      const headingText = $heading.text().trim();
      
      // Skip empty headings
      if (!headingText) {
        return; // continue to next heading
      }
      
      // Create unique ID for heading if it doesn't have one
      if (!$heading.attr('id')) {
        let slug = this.slugify(headingText);
        
        // Ensure unique ID by adding number suffix if needed
        if (usedIds[slug]) {
          usedIds[slug]++;
          slug = `${slug}-${usedIds[slug]}`;
        } else {
          usedIds[slug] = 1;
        }
        
        $heading.attr('id', slug);
      }

      const headingId = $heading.attr('id');

      // Create list item with link
      const $listItem = $('<li>', { class: 'toc-item' });
      const $link = $('<a>', {
        href: `#${headingId}`,
        class: 'toc-link',
        text: headingText,
      });
      
      // Add click handler for smooth scroll
      $link.on('click', (e) => {
        e.preventDefault();
        this.smoothScrollTo($heading);
      });

      $listItem.append($link);
      $tocContainer.append($listItem);
    });
    
    // Hide TOC if no valid items were generated
    if ($tocContainer.children().length === 0) {
      $('#blog-toc-wrapper').hide();
    }
  },

  /**
   * Initialize smooth scroll behavior
   */
  initializeSmoothScroll() {
    // Handle browser back/forward navigation
    $(window).on('hashchange', () => {
      const hash = window.location.hash;
      if (hash) {
        const $target = $(hash);
        if ($target.length) {
          this.smoothScrollTo($target);
        }
      }
    });

    // Handle initial hash on page load
    if (window.location.hash) {
      setTimeout(() => {
        const $target = $(window.location.hash);
        if ($target.length) {
          this.smoothScrollTo($target);
        }
      }, 100);
    }
  },

  /**
   * Smooth scroll to element
   * @param {jQuery} $element - Target jQuery element to scroll to
   */
  smoothScrollTo($element) {
    if (!$element || !$element.length) {
      return;
    }

    // Calculate offset (accounting for sticky header)
    const headerOffset = 100;
    const elementPosition = $element.offset().top;
    const offsetPosition = elementPosition - headerOffset;

    $('html, body').animate({
      scrollTop: offsetPosition,
    }, 600, 'swing');

    // Update URL hash without jumping
    const elementId = $element.attr('id');
    if (elementId) {
      history.pushState(null, null, `#${elementId}`);
    }
  },

  /**
   * Initialize Product Block Swiper slider
   */
  initializeProductBlock() {
    const $productBlock = $('.blog-product-block');
    
    if (!$productBlock.length) {
      return;
    }

    // Initialize Swiper for each product block (in case there are multiple)
    $productBlock.each(function() {
      const $this = $(this);
      
      // Initialize Swiper slider
      new Swiper($this[0], {
        modules: [Scrollbar, Autoplay],
        slidesPerView: 1.15,
        spaceBetween: 20,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2.15,
            spaceBetween: 25,
          },
          992: {
            slidesPerView: 3.15,
            spaceBetween: 30,
          },
        },
        autoplay: {
          delay: 6000,
          disableOnInteraction: true,
        },
      });
    });
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/blog.js